import styled from "styled-components";

const Label = styled.label`
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #adadad;
  font-size: 12px;
  margin-top: 16px;
  text-transform: uppercase;
`;

export default Label;
